import { useEffect, useState } from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Cell, ReferenceLine } from "recharts";
import api from "@/lib/api";

function Tip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-lg bg-pazer-deep/90 border border-white/10 px-3 py-2 text-xs space-y-0.5">
      <div className="font-bold">{d.date}</div>
      <div>Profit <span className={d.profit >= 0 ? "text-green-400" : "text-pazer-red"}>{Math.round(d.profit).toLocaleString()}</span></div>
      <div className="text-white/60">Wagered {Math.round(d.wagered).toLocaleString()} · Paid {Math.round(d.paid).toLocaleString()}</div>
      <div className="text-white/60">{d.games} games</div>
    </div>
  );
}

export function DailyProfitChart() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/admin/daily-profit", { params: { days: 30 } }).then(({ data }) => setData(data)).catch(() => {}); }, []);
  const total = data.reduce((s, d) => s + d.profit, 0);
  const rows = data.map((d) => ({ ...d, label: d.date.slice(5) }));
  return (
    <div className="rounded-2xl pz-glass p-6" data-testid="daily-profit-chart">
      <div className="flex items-end justify-between mb-4">
        <div>
          <h3 className="font-display font-bold text-lg">House profit · last 30 days</h3>
          <p className="text-xs text-white/40">Entry fees collected minus prizes paid, per day (UTC)</p>
        </div>
        <div className="text-right">
          <div className={`font-mono-pz font-bold text-2xl ${total >= 0 ? "text-green-400" : "text-pazer-red"}`} data-testid="daily-profit-total">{total >= 0 ? "+" : ""}{Math.round(total).toLocaleString()}</div>
          <div className="text-[10px] uppercase text-white/40">30-day total</div>
        </div>
      </div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={rows} margin={{ top: 5, right: 5, left: -10, bottom: 0 }}>
            <CartesianGrid stroke="rgba(255,255,255,0.05)" vertical={false} />
            <XAxis dataKey="label" tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 10 }} interval={2} axisLine={false} tickLine={false} />
            <YAxis tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 10 }} axisLine={false} tickLine={false} />
            <Tooltip content={<Tip />} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
            <ReferenceLine y={0} stroke="rgba(255,255,255,0.2)" />
            <Bar dataKey="profit" radius={[4, 4, 0, 0]}>
              {rows.map((d) => <Cell key={d.date} fill={d.profit >= 0 ? "#4ade80" : "#ef4444"} />)}
            </Bar>
            <Line type="monotone" dataKey="wagered" stroke="rgba(255,255,255,0.35)" strokeDasharray="4 4" dot={false} strokeWidth={1.5} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
